import React, { useContext, useRef, useState } from 'react';
import Time from './Time';
import DatePicker from 'react-multi-date-picker';
import { createUseStyles } from 'react-jss';
import moment from 'moment-jalaali';
import InputContext from '../../context/InputContext';
import { SET_FIELD } from '../../hooks/reducer';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { HandleChangeVisible, IFormPresentation, SelectValue } from '../../schema/interface';
import useAlgorithm from '../../hooks/useAlgorithm';
import useNonInitialEffect from '../../hooks/useNonIntialEffect';
import FormStructureContext from '../../context/FormStructureContext';

const CalendarIcon = (props: any) => {
    return (
        <svg
            fill="#fff"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            {...props}
        >
            <g fill="#989ea3" data-name="vuesax/outline/calendar">
                <path d="M8 5.75A.755.755 0 017.25 5V2A.755.755 0 018 1.25a.755.755 0 01.75.75v3a.755.755 0 01-.75.75z" />
                <path
                    d="M16 5.75a.755.755 0 01-.75-.75V2a.755.755 0 01.75-.75.755.755 0 01.75.75v3a.755.755 0 01-.75.75zM8.5 14.5a1 1 0 01-.38-.08 1.032 1.032 0 01-.33-.214 1.033 1.033 0 01-.29-.706 1 1 0 01.08-.38 1.155 1.155 0 01.21-.33 1.032 1.032 0 01.33-.21 1.021 1.021 0 011.09.21 1.052 1.052 0 01.29.71 1.5 1.5 0 01-.02.2.636.636 0 01-.06.18.757.757 0 01-.09.18 1.576 1.576 0 01-.12.15 1.052 1.052 0 01-.71.29zM12 14.501a1 1 0 01-.38-.08 1.032 1.032 0 01-.33-.21 1.033 1.033 0 01-.29-.71 1 1 0 01.08-.381 1.155 1.155 0 01.21-.33 1.032 1.032 0 01.33-.21 1 1 0 011.09.21 1.052 1.052 0 01.29.711 1.5 1.5 0 01-.02.2.636.636 0 01-.06.18.757.757 0 01-.09.18 1.576 1.576 0 01-.12.15 1.052 1.052 0 01-.71.29zM15.5 14.501a1 1 0 01-.38-.08 1.032 1.032 0 01-.33-.21l-.12-.15a.757.757 0 01-.09-.18.636.636 0 01-.06-.18 1.5 1.5 0 01-.02-.2 1.052 1.052 0 01.29-.711 1.032 1.032 0 01.33-.21 1 1 0 011.09.21 1.052 1.052 0 01.29.711 1.5 1.5 0 01-.02.2.636.636 0 01-.06.18.757.757 0 01-.09.18 1.576 1.576 0 01-.12.15 1.052 1.052 0 01-.71.29zM8.5 18a1 1 0 01-.38-.08 1.155 1.155 0 01-.33-.207A1.052 1.052 0 017.5 17a1 1 0 01.08-.38.933.933 0 01.21-.329 1.047 1.047 0 011.42 0A1.052 1.052 0 019.5 17a1.052 1.052 0 01-.29.71 1.052 1.052 0 01-.71.29zM12 18a1.052 1.052 0 01-.71-.287A1.052 1.052 0 0111 17a1 1 0 01.08-.38.933.933 0 01.21-.329 1.047 1.047 0 011.42 0 .933.933 0 01.21.33A1 1 0 0113 17a1.052 1.052 0 01-.29.71A1.052 1.052 0 0112 18zM15.5 17.999a1.052 1.052 0 01-.71-.29.933.933 0 01-.21-.33 1 1 0 01-.08-.38 1 1 0 01.08-.379.933.933 0 01.21-.33 1 1 0 01.9-.27.6.6 0 01.19.06.757.757 0 01.18.09 1.576 1.576 0 01.15.12 1.052 1.052 0 01.29.709 1.052 1.052 0 01-.29.71 1.052 1.052 0 01-.71.29zM20.5 9.84h-17a.755.755 0 01-.75-.75.755.755 0 01.75-.75h17a.755.755 0 01.75.75.755.755 0 01-.75.75z"
                    data-name="Vector"
                />
                <path
                    d="M16 22.75H8c-3.65 0-5.75-2.1-5.75-5.75V8.5c0-3.65 2.1-5.75 5.75-5.75h8c3.65 0 5.75 2.1 5.75 5.75V17c0 3.65-2.1 5.75-5.75 5.75zM8 4.25c-2.86 0-4.25 1.39-4.25 4.25V17c0 2.86 1.39 4.25 4.25 4.25h8c2.86 0 4.25-1.39 4.25-4.25V8.5c0-2.86-1.39-4.25-4.25-4.25z"
                    data-name="Vector"
                />
            </g>
        </svg>
    );
};
const styles = createUseStyles({
    datePicker: {
        padding: '.375rem .75rem',
        borderColor: '#bbbbbb',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '4px',
        backgroundColor: 'white',
        color: '#363636',
        lineHeight: '1.5',
        width: '100%',
        display: 'inline-block',
        height: 'calc(1.5em + .75rem + 2px)',
        fontSize: '1em',
        fontFamily: 'inherit',
        direction: 'ltr',
        '&:focus': {
            outline: 'none',
            borderColor: '#1b90fa',
            boxShadow: '0 0 0 0.2rem rgb(0 123 255 / 25%)'
        }
    },
    datePickerContainer: {
        position: 'relative',
        width: '100%',
        marginInlineEnd: (hasTime) => (hasTime ? '6px' : '0'),
        '& svg': {
            position: 'absolute',
            top: '5px',
            right: '5px',
            pointerEvents: 'none'
        }
    },
    dateTimeContainer: {
        display: 'flex'
    }
});
interface DateTimeProps {
    hasTime?: boolean;
    value: string;
    name: string;
    presentation: IFormPresentation;
    handleChangeVisible: HandleChangeVisible;
    formValues: { [key: string]: string | string[] | SelectValue };
    noAccess?: boolean;
}

const DateTimeInput = ({
    hasTime,
    value,
    presentation,
    name,
    handleChangeVisible,
    formValues,
    noAccess,
    ...props
}: DateTimeProps) => {
    const classes = styles(hasTime);
    const { dispatch } = useContext(InputContext);
    const [time, setTime] = useState('');
    const [dateValue, setDateValue] = useState('');
    const [editedHour, setEditedHour] = useState('');
    const [editedMinute, setEditedMinute] = useState('');
    const datePickerRef = useRef(null);
    const { fetchedFormStructure: formStructure } = useContext(FormStructureContext);
    const rtl = formStructure?.presentation?.rtl;
    const lang = rtl ? 'bottom-right' : 'bottom-left';
    const [isChanging, setIsChanging] = useState('');
    const date = dateValue ? dateValue.split('T')?.[0] : value.split('T')?.[0];

    const { handleAlgorithmCode } = useAlgorithm({
        formStructure,
        formValues,
        handleChangeVisible
    });

    useNonInitialEffect(() => {
        dispatch({
            type: SET_FIELD,
            name,
            value: time ? `${dateValue}T${time}:00+03:30` : dateValue
        });
    }, [dateValue, time]);

    const handleDateChange = (val) => {
        const date = new Date(val);
        const formatDate = moment(date).format('YYYY-MM-DD');
        setIsChanging('changed');
        setDateValue(val ? formatDate : '');
        if (hasTime) {
            const time = `${editedHour?.toString()}:${editedMinute?.toString()}`;
            if (time?.length > 1) {
                setTime(time);
            }
        }
    };

    useNonInitialEffect(() => {
        if (isChanging === 'changed' && value && !hasTime) {
            handleAlgorithmCode();
        }
    }, [isChanging, value, hasTime]);

    return (
        <div className={classes.dateTimeContainer}>
            <div
                className={classes.datePickerContainer}
                onKeyDown={(e) => {
                    if (e.key === 'Tab') {
                        datePickerRef.current.closeCalendar();
                    }
                }}
                onFocus={() => setIsChanging('changing')}
            >
                <DatePicker
                    value={value?.includes('T') ? new Date(date) : new Date(date)}
                    inputClass={classes.datePicker}
                    calendarPosition={lang}
                    calendar={persian}
                    locale={persian_fa}
                    onChange={handleDateChange}
                    arrow={false}
                    zIndex={10000000}
                    required={presentation?.required}
                    disabled={noAccess}
                    ref={datePickerRef}
                    onClose={() => setIsChanging('changed')}
                    {...props}
                />
                <CalendarIcon fill="#ccc" width="21px" height="21px" />
            </div>

            {hasTime && (
                <Time
                    name={name}
                    value={value}
                    setTime={setTime}
                    setDate={setDateValue}
                    editedHour={editedHour}
                    setEditedHour={setEditedHour}
                    editedMinute={editedMinute}
                    setEditedMinute={setEditedMinute}
                    required={presentation?.required}
                    handleAlgorithmCode={handleAlgorithmCode}
                    noAccess={noAccess}
                    isChanging={isChanging}
                />
            )}
        </div>
    );
};
export default DateTimeInput;
